// extracted by mini-css-extract-plugin
export default {"image":"Avatar__image___XSNUr","userIconWrapper":"Avatar__userIconWrapper___lTXoG","whiteBg":"Avatar__whiteBg___jkSWK","userIcon":"Avatar__userIcon___docJs fa fa-user"};